import {Button as ChakraButton} from '@chakra-ui/react'
import {createLink, LinkComponent} from '@tanstack/react-router'
import * as React from 'react'

type ChakraButtonProps = React.ComponentPropsWithoutRef<typeof ChakraButton>

const ChakraButtonComponent = React.forwardRef<HTMLButtonElement, ChakraButtonProps>((props, ref) => {
  return <ChakraButton ref={ref} as="a" {...props} />
})

const CreatedLinkButton = createLink(ChakraButtonComponent)

export const LinkButton: LinkComponent<typeof ChakraButtonComponent> = props => {
  return <CreatedLinkButton preload={'intent'} variant="solid" {...props} />
}
